import { render, staticRenderFns } from "./QuotaholdersOperationsView.vue?vue&type=template&id=7b804340&scoped=true&"
import script from "./QuotaholdersOperationsView.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersOperationsView.vue?vue&type=script&lang=js&"
import style0 from "./QuotaholdersOperationsView.vue?vue&type=style&index=0&id=7b804340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b804340",
  null
  
)

export default component.exports